import React, { useEffect } from 'react';

const LoadingIcon = ({ onLoadingComplete }) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      onLoadingComplete();
    }, 1000);

    return () => clearTimeout(timer);
  }, [onLoadingComplete]);

  return (
    <div className="position-fixed w-100 h-100 bg-white" 
         style={{ 
           zIndex: 9999,
           top: 0,
           left: 0
         }}>
      <div className="position-absolute top-50 start-50 translate-middle">
        <div className="text-center">
          <img 
            src="/assets/klm icon.jpg" 
            alt="klmLogo" 
            className="img-fluid"
            style={{ 
              width: '80px',  // Reduced from 150px
              height: '80px', // Reduced from 150px
              animation: 'bounce 1s infinite'
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default LoadingIcon;